import React from 'react';
import { useLocation } from 'react-router-dom';
import EpdRoutes from 'routes/EpdRoutes';

const routesWhereNoLayout = new Set([
  EpdRoutes.login,
  EpdRoutes.welcome,
  EpdRoutes.account.register.user,
  EpdRoutes.account.register.userError,
  EpdRoutes.account.register.userSuccess,
  EpdRoutes.account.confirmEmail,
  EpdRoutes.account.forgotPassword,
  EpdRoutes.account.forgotPasswordSuccess,
  EpdRoutes.account.resetPassword,
  EpdRoutes.account.resetPasswordSuccess,
  EpdRoutes.account.resetPasswordTokenError,
]);

const HideWhenNoLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  if (routesWhereNoLayout.has(location.pathname)) {
    return null;
  }

  return children;
};

export default HideWhenNoLayout;
